<template>
    <div>
        <transition name="fade">
            <div class="fi-header">
                <div class="hl"></div>
                <div class="hr">
                    <ul class="link clearfix">
                        <li @click="headerHandle(index)" :key="index" v-for="(item,index) in headerText" :class="{'active':headerActive[index]}">
                            {{item.name}}
                        </li>
                    </ul>
                    <div v-if="!regBox.isUserShow" class="fun">
                        <ul class="clearfix">
                            <li class="btn login" @click="loginHandle">登录</li>
                            <li class="btn register" @click="regHandle">注册</li>
                        </ul>
                    </div>
                    <div v-if="regBox.isUserShow" class="login-box">
                        <i></i>
                        <span>{{regBox.phone}}</span>
                        <ul>
                            <li @click="changeUserHandle">切换账户</li>
                            <li @click="logout">退出登录</li>
                        </ul>
                    </div>
                </div>
            </div>
        </transition>
        <reg-box :reg-box="regBox"></reg-box>
    </div>
</template>
<style lang="scss" scoped>

</style>
<script>
    import RegBox from '../regbox/index.vue'
    export default {
        components: {
            RegBox
        },
        data() {
            return {
                // ,'商务合作','帮助中心'
                regBox: {
                    show: false,
                    status: '',
                    isUserShow: false,
                    phone: ''
                },
                userPhone: '',
                headerText: [{
                    name: '首页',
                    route: 'flatindex'
                }, {
                    name: '关于我们',
                    route: 'aboutus'
                }, {
                    name: '商务合作',
                    route: 'cooperate'
                }, {
                    name: '帮助中心',
                    route: 'helpcenter'
                }],
                headerActive: [true],
            }
        },
        mounted() {
            // console.log(this.$route.path);
            let routeName = []
            this.headerText.forEach((e) => {
                routeName.push(e.route)
            })
            let index = routeName.indexOf(this.$route.path.replace('/', ''))
            this.headerActive = []
            this.headerActive[index] = true

            if (this.$storage.getItem('user').accessKey) {
                this.regBox.phone = this.$storage.getItem('user').phone
                this.regBox.isUserShow = true
            } else {
                this.regBox.isUserShow = false
            }
        },
        methods: {
            headerHandle(index) {
                // console.log(index);
                this.headerActive = []
                this.headerActive[index] = true
                this.$router.push(this.headerText[index].route)
            },
            loginHandle() {
                this.regBox.show = true
                this.regBox.status = 0
            },
            regHandle() {
                this.regBox.show = true
                this.regBox.status = 1
            },
            changeUserHandle() {
                this.regBox.show = true
                this.regBox.status = 0
            },
            logout() {
                this.$storage.init()
                this.regBox.isUserShow = false
            }
        }
    }
</script>



// WEBPACK FOOTER //
// index.vue?7b135eb7